import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "chart-error" }

import NoDataIcon from '@/shared/icons/InsertChartOutlined.vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'ChartNoData',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(NoDataIcon, { class: "error-icon" }),
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "error-text" }, "No data to display", -1))
  ]))
}
}

})